<section class="w-full h-full bg-white dark:bg-slate-800 flex flex-col p-5">
  <!-- Form -->
  <form class="flex-1 flex flex-col">
    <div class="flex-1">
      <!-- Upload Section -->
      <div class="mb-6">
        <label class="block text-xs font-normal text-gray-600 dark:text-slate-400 mb-1.5">
          Upload member list for this institution
        </label>

        <!-- Download Sample CSV -->
        <div (click)="downloadSampleCSV()"
          class="flex items-center gap-2 mb-3 text-primary-500 cursor-pointer hover:text-primary-900 transition-colors">
          <span class="text-xs font-normal">View sample csv</span>
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path>
          </svg>
        </div>

        <!-- File Upload Area -->
        <div class="bg-gray-50 dark:bg-slate-800 rounded-lg p-4 border border-gray-200 dark:border-slate-700">
          @if (csvFile != null) {
          <!-- File Uploaded -->
          <div class="bg-white dark:bg-slate-800 rounded-lg p-4 shadow-sm border border-gray-200 dark:border-slate-700">
            <!-- File Info -->
            <div class="flex items-center justify-between mb-3">
              <div class="flex items-center gap-3">
                <div class="p-2 bg-green-100 rounded-lg">
                  <svg class="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z">
                    </path>
                  </svg>
                </div>
                <div>
                  <p class="text-xs font-normal text-gray-900 dark:text-white">{{ csvFile.name }}</p>
                  <p class="text-xs text-gray-500 dark:text-slate-400">{{ getFileSize() }}</p>
                </div>
              </div>
              <button type="button" class="p-2 text-red-500 hover:bg-red-50 rounded-lg transition-colors"
                (click)="csvFile = null">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16">
                  </path>
                </svg>
              </button>
            </div>

            <!-- Progress Bar -->
            <div class="space-y-1">
              <div class="flex items-center justify-between text-xs">
                <span class="text-gray-600 dark:text-slate-400">Upload complete</span>
                <span class="font-medium text-green-600">100%</span>
              </div>
              <div class="w-full bg-gray-200 rounded-full h-2">
                <div class="bg-gradient-to-r from-green-500 to-green-600 h-2 rounded-full" style="width: 100%"></div>
              </div>
            </div>
          </div>
          } @else {
          <!-- Upload Prompt -->
          <div
            class="flex flex-col items-center justify-center py-12 px-4 bg-white dark:bg-slate-800 rounded-lg border-2 border-dashed border-gray-300 dark:border-slate-600 hover:border-primary-500 transition-colors cursor-pointer"
            (click)="fileInput.click()">
            <div class="p-3 bg-primary-50 rounded-full mb-3">
              <svg class="w-8 h-8 text-primary-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"></path>
              </svg>
            </div>
            <p class="text-xs font-normal text-gray-900 dark:text-white mb-1">Upload your CSV file here</p>
            <p class="text-xs text-gray-500 dark:text-slate-400">Click to browse or drag and drop</p>
            <p class="text-xs text-gray-400 mt-2">Supported format: .csv</p>
          </div>

          <input type="file" class="hidden" #fileInput (change)="onFileSelected($event)" accept=".csv" />
          }
        </div>
      </div>
    </div>

    <!-- Submit Button -->
    <div class="mt-auto pt-4 border-t border-gray-200 dark:border-slate-700">
      <app-primary-button [text]="csvFile ? 'Upload Members' : 'Select File First'" [isLoading]="isLoading"
        [isDisabled]="!csvFile" (onClickEvent)="onSubmit()"></app-primary-button>
    </div>
  </form>
</section>